var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e0e2e2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82 14.42a6.07 6.07 0 010-8.58 6.11 6.11 0 0110.43 4.31 6 6 0 01-1.79 4.3 6.1 6.1 0 01-8.64-.03zM22 20.57l-5.46-5.45a8 8 0 001.74-5 8.09 8.09 0 10-3.14 6.43L20.56 22z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchmin);
export default __webpack_public_path__ + "static/media/search.min.9aabfee48f803205e747256638903576.svg";
export { ForwardRef as ReactComponent };